function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M 50 8 A 30 30 0 1 0 21 59 30 30 0 0 1 41 36 30 30 0 0 1 50 8",
  strokeDasharray: "1 1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 50 8 A 30 30 0 1 1 79 59 30 30 0 0 0 59 36 30 30 0 0 0 50 8",
  strokeDasharray: "1 1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 21 59 A 30 30 0 1 0 79 59 30 30 0 0 1 50 52 30 30 0 0 1 21 59",
  strokeDasharray: "1 1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 50 52 A 30 30 0 0 1 21 59 30 30 0 0 1 41 36 30 30 0 0 0 50 52",
  strokeDasharray: "1 1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 50 8 A 30 30 0 0 0 41 36 30 30 0 0 1 59 36 30 30 0 0 0 50 8",
  strokeDasharray: "1 1"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 50 52 A 30 30 0 0 0 79 59 30 30 0 0 0 59 36 30 30 0 0 1 50 52",
  strokeDasharray: "1 1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M 50 52 A 30 30 0 0 1 41 36 30 30 0 0 1 59 36 30 30 0 0 1 50 52",
  strokeDasharray: "1 1"
});

var SvgVenn = function SvgVenn(props) {
  return React.createElement("svg", _extends({
    height: "99%",
    width: "99%",
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB2ZXJzaW9uPSIxLjEiCiAgaGVpZ2h0PSI5OSUiCiAgd2lkdGg9Ijk5JSIKICB2aWV3Qm94PSIwIDAgMTAwIDEwMCIKICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIKPgogIDxwYXRoIGQ9Ik0gNTAgOCBBIDMwIDMwIDAgMSAwIDIxIDU5IDMwIDMwIDAgMCAxIDQxIDM2IDMwIDMwIDAgMCAxIDUwIDgiIHN0cm9rZS1kYXNoYXJyYXk9IjEsMSIgLz4KICA8cGF0aCBkPSJNIDUwIDggQSAzMCAzMCAwIDEgMSA3OSA1OSAzMCAzMCAwIDAgMCA1OSAzNiAzMCAzMCAwIDAgMCA1MCA4IiBzdHJva2UtZGFzaGFycmF5PSIxLDEiIC8+CiAgPHBhdGggZD0iTSAyMSA1OSBBIDMwIDMwIDAgMSAwIDc5IDU5IDMwIDMwIDAgMCAxIDUwIDUyIDMwIDMwIDAgMCAxIDIxIDU5IiBzdHJva2UtZGFzaGFycmF5PSIxLDEiIC8+CiAgPHBhdGggZD0iTSA1MCA1MiBBIDMwIDMwIDAgMCAxIDIxIDU5IDMwIDMwIDAgMCAxIDQxIDM2IDMwIDMwIDAgMCAwIDUwIDUyIiBzdHJva2UtZGFzaGFycmF5PSIxLDEiIC8+CiAgPHBhdGggZD0iTSA1MCA4IEEgMzAgMzAgMCAwIDAgNDEgMzYgMzAgMzAgMCAwIDEgNTkgMzYgMzAgMzAgMCAwIDAgNTAgOCIgc3Ryb2tlLWRhc2hhcnJheT0iMSwxIiAvPgogIDxwYXRoIGQ9Ik0gNTAgNTIgQSAzMCAzMCAwIDAgMCA3OSA1OSAzMCAzMCAwIDAgMCA1OSAzNiAzMCAzMCAwIDAgMSA1MCA1MiIgc3Ryb2tlLWRhc2hhcnJheT0iMSwxIiAvPgogIDxwYXRoIGQ9Ik0gNTAgNTIgQSAzMCAzMCAwIDAgMSA0MSAzNiAzMCAzMCAwIDAgMSA1OSAzNiAzMCAzMCAwIDAgMSA1MCA1MiIgc3Ryb2tlLWRhc2hhcnJheT0iMSwxIiAvPgo8L3N2Zz4=";
export { SvgVenn as ReactComponent };